import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  AfterViewInit
} from '@angular/core'
import { ScriptResponse } from '../../../../../action-module/models/script-action'
import { fromEvent, Observable, Subject, timer } from 'rxjs'
import { tap, takeUntil, switchMap, filter } from 'rxjs/operators'
import { Dashlet, EntityReference } from '../../../..'
import { ActionService } from '../../../../../action-module/services/action.service'

@Component({
  selector: 'jml-lib-log-dashlet',
  templateUrl: './log-dashlet.component.html',
  styleUrls: ['./log-dashlet.component.scss']
})
export class LogDashletComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() dashlet: Dashlet
  @Input() entityReference: EntityReference

  @ViewChild('scrollableDiv') scrollableDiv: ElementRef
  @ViewChild('logSpan') logSpan: ElementRef

  actionResponse$: Observable<ScriptResponse>

  // initially loaded is for the cases where there is no interval defined and we just read the log once,
  // showPause as well (it is true when the pause button is not needed, if no interval is defined)
  initiallyLoaded = false
  showPause = false

  isPaused = false

  weScrolled = false

  private destroy$ = new Subject<void>()

  constructor(private actionService: ActionService) {}

  initActionObservable() {
    this.initiallyLoaded = false
    this.isPaused = false

    const action = { actionHrid: this.dashlet.actionHrid, entityReference: this.entityReference }
    const baseAction$ = this.actionService.executeAction(action, false).pipe(
      tap(() => {
        setTimeout(() => {
          if (this.scrollableDiv && this.logSpan) {
            this.weScrolled = true
            this.scrollableDiv.nativeElement.scrollTo(0, this.logSpan.nativeElement.offsetHeight)
          }
        }, 50)
      })
    )

    if (!this.dashlet.refreshInterval) {
      this.actionResponse$ = baseAction$
      this.showPause = false
    } else {
      this.showPause = true
      // the 0 means immediate emitting
      this.actionResponse$ = timer(0, this.dashlet.refreshInterval * 1000).pipe(
        takeUntil(this.destroy$),
        filter(() => !this.initiallyLoaded || !this.isPaused),
        tap(() => (this.initiallyLoaded = true)),
        switchMap(() => baseAction$)
      )
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entityReference && !changes.entityReference.firstChange) {
      this.initActionObservable()
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  ngOnInit(): void {
    this.initActionObservable()
  }

  private setupScrollListener(): void {
    // create scroll observable with debouncing
    fromEvent(this.scrollableDiv.nativeElement, 'scroll')
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          if (this.weScrolled) {
            this.weScrolled = false
          } else {
            // user scrolled
            this.isPaused = true
          }
        })
      )
      .subscribe()
  }

  ngAfterViewInit(): void {
    this.setupScrollListener()
  }
}
